import React from 'react';
import {
  TitleDescription,
  ContentDescription,
  IconWrapperDescription,
  ShortDescriptionWrapper,
} from './styled';

export default function ShortDescriptionContent({Icon, title, content}) {
  return (
    <ShortDescriptionWrapper>
      <IconWrapperDescription>{Icon}</IconWrapperDescription>

      <TitleDescription>{title}</TitleDescription>
      <ContentDescription>{content}</ContentDescription>
    </ShortDescriptionWrapper>
  );
}
